const INN_MASK = "############";

const normalizeInn = value => {
  return String(value ?? "")
    .replace(/\D/g, "")
    .slice(0, INN_MASK.length);
};

const isValidInn = value => {
  return /^(?:\d{10}|\d{12})$/.test(String(value ?? ""));
};

module.exports = {
  INN_MASK,
  normalizeInn,
  isValidInn,
};
